import * as React from "react";

export type PreviewModeContextType = {
    handlePreviewModeSubmitButtonClick: () => void;
    isPreviewMode: boolean;
};

export const PreviewModeContext = React.createContext<
    PreviewModeContextType | undefined
>(undefined);
